import './App.css'

import {HashRouter, Switch, Route, Redirect} from 'react-router-dom'

import Login from './components/Login'
import Home from './components/Home'
import Jobs from './components/Jobs'
import ProtectedRoute from './components/ProtectedRoute'
import NotFound from './components/NotFound'
import JobItemDetails from './components/JobItemDetails'

const App = () => (
  <HashRouter>
    <Switch>
      <Route exact path="/login" component={Login} />

      <ProtectedRoute exact path="/" component={Home} />

      <ProtectedRoute exact path="/jobs" component={Jobs} />

      <ProtectedRoute exact path="/jobs/:id" component={JobItemDetails} />

      <Route exact path="/not-found" component={NotFound} />

      <Redirect to="/not-found" />
    </Switch>
  </HashRouter>
)

export default App